import React, {useContext} from 'react'
import {Languages} from "./Home"
import "../styles/ennesimaAgenzia.scss"

export default function EnnesimaAgenzia() {
    const lang = useContext(Languages)
    return (
        <div className='ennesima_agenzia_section max-w' >
            <h1 className='titolo' data-aos="zoom-out-up" data-aos-duration="1000">
                {lang["L'ennesima"]} <br />
                {lang["agenzia"]} <br />
                {lang["immobiliare"]} <br />
            </h1>
            <h2 className='sottotitolo' data-aos="zoom-out-up" data-aos-duration="1000" data-aos-delay="300">
                {lang['E questo qui è...']}
            </h2>
            
            
            <a href="#manifesto"><button data-aos="flip-left" data-aos-duration="1000" data-aos-delay="500" className="button_outline">{lang['leggi il manifesto']}</button></a>
        </div>
    )
}
